// Shared time-range labels for Insights (PRD-1467). One source of truth for the
// preset -> human label used by the widget card footer and the summary-row tiles,
// so a composite's per-tile ranges read the same way the single-widget footer does.

import { formatDateRange } from '../../../shared/datetime/timestamps';

export const PRESET_LABELS = {
  '7d': 'Last 7 days',
  '30d': 'Last 30 days',
  '60d': 'Last 60 days',
  '90d': 'Last 90 days',
  '6m': 'Last 6 months',
  '12m': 'Last 12 months',
  '1y': 'Last 12 months',
  ytd: 'Year to date',
  next_7d: 'Next 7 days',
  next_30d: 'Next 30 days',
  next_90d: 'Next 90 days',
  next_12m: 'Next 12 months',
  this_week: 'This week',
  this_month: 'This month',
  this_quarter: 'This quarter',
};

// A time_range token -> readable label. `all`/empty is "All time"; custom:<from>:<to>
// decodes to the span; otherwise the preset map (unknown tokens pass through).
export function presetRangeLabel(timeRange) {
  if (!timeRange || timeRange === 'all') return 'All time';
  if (timeRange.startsWith('custom:')) {
    const [, from, to] = timeRange.split(':');
    return from && to ? formatDateRange(from, to) : 'Custom range';
  }
  return PRESET_LABELS[timeRange] || timeRange;
}

// The header for a range: the dates the server resolved it to when it has them, the
// preset's name only when it does not. The dates are what the reader needs -- "Last
// 30 days" does not say which thirty, and on a card that has not refreshed since
// yesterday it is not the thirty the reader would assume. The server resolves them in
// the organisation's zone, so the browser's own clock never decides which day it is.
// They are worded here, from the dates themselves: the server's own label is for the
// agent and is never shown.
export function rangeLabel(timeRange, resolved) {
  if (resolved?.from && resolved?.to) return formatDateRange(resolved.from, resolved.to);
  return presetRangeLabel(timeRange);
}
